import ClientSafeError from '../../utils/ClientSafeError';

// eslint-disable-next-line import/prefer-default-export
export class ValidationError extends ClientSafeError {
  constructor(errors, reason) {
    super('validation-error', reason, errors);
    this.name = 'ValidationError';
  }
}
